import React from "react";
import "../../assets/css/merit.css";
import MeritCard from "./MeritCard";
import MeritImageA from "../../assets/img/src/shingan_doc_protect.png";
import MeritImageB from "../../assets/img/src/shingan_doc_artist-support.png";
import MeritImageC from "../../assets/img/src/shingan_merit_pc.png";
import MeritImageD from "../../assets/img/src/shingan_doc_flow.png";

const MeritArea = (props) => {
  return (
    <section className="merit-container" id={props.id}>
      <div className="merit-container--inner yu-gothic center-box center">
        <div className="merit-headline">- ShinGanの特徴 -</div>
        <div className="spacer-box--l" />

        <div className="grid__row--around">
          <MeritCard
            image={MeritImageA}
            title="唯一無二のデータ生成"
            textA="Shinganは作品を登録する時に特殊な技術(特許出願中)を使って唯一無二のデータを生成します。"
            textB="そのデータを使い、贋作を撤廃し、作品価値を守ります。"
            notes="出典: shingan Guidance 2021 "
          />
          <MeritCard
            image={MeritImageB}
            title="作家に優しい設計"
            textA="Shinganで作品を登録すれば、市場で流通するたびに作家に支援金が入る仕組みが手に入ります。"
            textB="「流通」というのは”売却”だけでなく美術館などへの”貸出”も含まれます。"
            notes="出典: shingan Guidance 2021 "
          />
          <MeritCard
            image={MeritImageC}
            title="価値を上げる来歴管理"
            textA="Shinganで登録された所有権が移動するたびに鑑定され、その時に来歴も登録されます。"
            textB="来歴は作品の実績のような意味合いを持ち、価値を上げる効果が期待できるでしょう。"
          />
          <MeritCard
            image={MeritImageD}
            title="登録も鑑定も送るだけ"
            textA="Shingangは「登録」も「鑑定」も送るだけのシンプルなフローになっています。"
            textB="鑑定通知はデータで発行されますが、任意で紙の発行も可能です。"
            notes="出典: shingan Guidance 2021 "
          />
        </div>
      </div>
    </section>
  );
};
export default MeritArea;
